import React from 'react';
import { Grid, Paper, Typography, Box } from '@mui/material';

const StatsCards = ({ stats }) => {
  if (!stats || stats.length === 0) {
    return (
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Paper sx={{ p: 3, textAlign: 'center' }}>
            <Typography>Loading statistics...</Typography>
          </Paper>
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid container spacing={3}>
      {stats.map((stat, index) => (
        <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
          <Paper
            elevation={0}
            sx={{
              p: 2,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              borderRadius: 2,
              border: '1px solid #e0e0e0',
              transition: 'transform 0.2s, box-shadow 0.2s',
              '&:hover': {
                transform: 'translateY(-4px)',
                boxShadow: 3,
                border: `1px solid ${stat.color}`,
              },
              cursor: 'pointer',
            }}
          >
            <Box>
              <Typography variant="body2" color="textSecondary">
                {stat.title}
              </Typography>
              <Typography variant="h4" fontWeight="bold" mt={1}>
                {stat.value}
              </Typography>
            </Box>
            <Box
              sx={{
                background: `linear-gradient(135deg, ${stat.color}20 0%, ${stat.color}10 100%)`,
                borderRadius: '50%',
                p: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {React.cloneElement(stat.icon, { sx: { color: stat.color, fontSize: 32 } })}
            </Box>
          </Paper>
        </Grid>
      ))}
    </Grid>
  );
};

export default StatsCards;